import apiClient from "@/services/axios";

export async function put(dto) {
  var response = await apiClient.put("/CockpitReports", dto);
  if (response) {
    return response.data;
  }

  throw new Error("Unable to update cockpit report.");
}
